/**
 * 获取绑定 / 解绑事件监听的 binder 函数，用于在一个函数中同时实现事件绑定和解绑的逻辑
 *```typescript
 *class MyPlugin {
 *   public constructor() {
 *     this.bindEvents(true);
 *   }
 *
 *   public destroy() {
 *     this.bindEvents(false);
 *   }
 *
 *   protected bindEvents(isBind: boolean) {
 *     const binder = getBinder(player, isBind);
 *     binder(MY_EVENT, this.onEventTrigger);
 *   }
 *}
 *```
 * @param emitter 继承于 EvtEmitter（player / plugin）的事件派发器
 * @param isBind 是否为绑定，true 返回 on，false 则返回 off 函数
 */
export function getEventEmitterBinder(emitter, isBind) {
    return isBind ? emitter.on.bind(emitter) : emitter.off.bind(emitter);
}
/**
 * 获取绑定 / 解绑事件监听的 binder 函数，用于在一个函数中同时实现事件绑定和解绑的逻辑
 *```typescript
 *class MyPlugin {
 *   public constructor() {
 *     this.bindEvents(true);
 *   }
 *
 *   public destroy() {
 *     this.bindEvents(false);
 *   }
 *
 *   protected bindEvents(isBind: boolean) {
 *     const binder = getBinder(video as HTMLVideoElement, isBind);
 *     binder('pause', this.onVideoPause);
 *   }
 *}
 *```
 * @param emitter 继承于 EventTarget(HTMLElement）的事件派发器
 * @param isBind 是否为绑定，true 返回 addEventListener，false 则返回 removeEventListener 函数
 */
export function getEventTargetBinder(emitter, isBind) {
    return isBind ? emitter.addEventListener.bind(emitter) : emitter.removeEventListener.bind(emitter);
}
